import { useState, useEffect } from 'react';

import { getApiUrl } from "../utils/config";
const API_URL = getApiUrl();

export const useGameCategories = (mode = 'sidebar') => {
    const [categories, setCategories] = useState({});
    const [iconModeCategories, setIconModeCategories] = useState([]);
    const [collections, setCollections] = useState([]);
    const [subcollections, setSubcollections] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchCategories();
    }, [mode]);

    const fetchCategories = async () => {
        try {
            setLoading(true);
            const params = new URLSearchParams();
            if (mode) {
                params.append('mode', mode);
            }

            // Используем единый эндпоинт
            const response = await fetch(`${API_URL}/api/collections?${params}`);

            if (!response.ok) {
                throw new Error('Ошибка при загрузке категорий');
            }

            const data = await response.json();

            if (data.success) {
                setCategories(data.categories || {});
                setIconModeCategories(data.iconModeCategories || []);
                setCollections(data.collections || []);
                setSubcollections(data.subcollections || {});
            } else {
                throw new Error('Ошибка в ответе сервера');
            }
        } catch (err) {
            console.error('Ошибка при загрузке категорий:', err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return {
        categories,
        iconModeCategories,
        collections,
        subcollections,
        loading,
        error
    };
};

export const useAllCategories = () => {
    const [allCategories, setAllCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchAllCategories();
    }, []);

    const fetchAllCategories = async () => {
        try {
            setLoading(true);
            // Используем единый эндпоинт с параметром mode=all
            const response = await fetch(`${API_URL}/api/collections?mode=all`);

            if (!response.ok) {
                throw new Error('Ошибка при загрузке всех категорий');
            }

            const data = await response.json();

            if (data.success) {
                // Формируем плоский список из коллекций и подколлекций
                const allCategories = [];

                // Добавляем основные коллекции
                if (data.collections) {
                    data.collections.forEach(collection => {
                        allCategories.push({
                            key: collection.key,
                            titleKey: collection.titleKey,
                            icon: collection.icon,
                            fullPath: collection.key,
                            hasSubcategories: collection.hasSubcategories
                        });
                    });
                }

                // Добавляем подкатегории
                if (data.subcollections) {
                    Object.entries(data.subcollections).forEach(([parentKey, subcats]) => {
                        subcats.forEach(subcat => {
                            allCategories.push({
                                key: subcat.key,
                                titleKey: subcat.titleKey,
                                icon: subcat.icon,
                                fullPath: `${parentKey}.${subcat.key}`,
                                parent: parentKey
                            });
                        });
                    });
                }

                setAllCategories(allCategories);
            } else {
                throw new Error('Ошибка в ответе сервера');
            }
        } catch (err) {
            console.error('Ошибка при загрузке всех категорий:', err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return { allCategories, loading, error };
};
